import React from 'react';
import { ListStore } from 'shared/stores/ListStore';
import { observer } from 'mobx-react';
import ClientChangelogTable from '../components/ClientChangelogTable';
import { clientChangelogStore } from '../components/ClientChangelogStore';
import { Pagination } from 'ats/components/pagination/Pagination';
import Dropdown from 'ats/components/dropdown/Dropdown';
import ChangelogEmptyState from 'ats/components/empty-state/ChangelogEmptyState';

@observer
export class ClientChangelog extends React.Component {
	constructor(props) {
		super(props);
		this.listStore = new ListStore(clientChangelogStore, {
			entityName: 'Client Changelog'
		});
		this.listStore.beginLoading();
	}

	loadClientChangelog = client => {
		if (!client?.id) return;

		clientChangelogStore.setQuery('clientId', client.id);
		clientChangelogStore.setQuery('sort', {
			column: 'createdAt',
			asc: false
		});
		this.listStore.search();
	};

	componentDidMount() {
		this.loadClientChangelog(this.props.client);
	}

	componentDidUpdate(prevProps) {
		const { client } = this.props;

		if (prevProps.client?.id !== client?.id && client?.id) {
			this.loadClientChangelog(client);
		}
	}

	handlePaginationChange = value => {
		this.listStore.handlePaginationChange(
			value,
			this.listStore.store.query.pagination.limit
		);
	};

	render() {
		const typeFilterDropdown = (
			<Dropdown
				value={this.listStore.store.query.columnName}
				name="columnName"
				onChange={newValue => {
					this.listStore.store.setQuery('columnName', newValue);
					this.handlePaginationChange(1);
				}}
				optionValue="value"
				options={[
					{ label: 'All', value: null },
					...clientChangelogStore.typeOptions
				]}
				placeholder="All"
				displayValue={value => `Type: ${value}`}
			/>
		);

		const showEmptyState =
			!this.listStore.loading && this.listStore.data.length === 0;
		const hasEntries = this.listStore.data.length > 0;

		return (
			<div className="client-changelog-tab">
				<div className="client-tab-section-header client-changelog-section-header">
					<div className="client-tab-section-title">Log</div>
					<div className="table-action-buttons client-changelog-header-tools">
						<Pagination
							loading={this.listStore.loading}
							pagination={this.listStore.store.query.pagination}
							onPaginationChange={this.handlePaginationChange}
							hidePageControls
							customButton={typeFilterDropdown}
						/>
					</div>
				</div>
				<div className="client-changelog">
					<ClientChangelogTable
						data={this.listStore.data}
						sort={this.listStore.store.query.sort}
						onSort={this.listStore.handleSort}
						isEmpty={showEmptyState}
						loading={this.listStore.loading}
						emptyState={<ChangelogEmptyState />}
					/>
					{hasEntries ? (
						<Pagination
							loading={this.listStore.loading}
							pagination={this.listStore.store.query.pagination}
							onPaginationChange={this.handlePaginationChange}
							hideLimitSelect
						/>
					) : null}
				</div>
			</div>
		);
	}
}
